// ─── Industry-matched testimonials ───────────────────────────────────────────
// Placeholder — awaiting real customer results.
// When real testimonials are collected, add them here keyed by industry.
export const TESTIMONIAL_BANK = {
  default: [],
};
